/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useMemo, useEffect, useRef } from "react";
import { IoArrowBack, IoLockClosed, IoMail, IoPerson } from "react-icons/io5";
import check from "../../assets/verified.svg";
import { ThemeContext } from "../../pages/qcast-logo";
import Sign from "../../api/api-sign";
import config from "../../config/config";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";

export const SignupFirstStep = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const userEmail = useSelector((store) => store.auth.email);
  const [email, setEmail] = useState(userEmail);

  const [isCaptchaPassed, setIsCaptchaPassed] = useState(false);
  const dispatch = useDispatch();
  const recaptcha = useRef(null);

  const { signup } = Sign();

  const startSignup = () => {
    if (isCaptchaPassed) {
      signup(email, ({ id, msg }) => {
        if (id === 200) {
          dispatch({ type: "auth/setEmail", payload: email });
          props.verify();
        } else {
          alert(msg);
        }
      });
    } else {
      alert("Complete recaptcha challenge");
    }
  };

  const handleRecaptcha = (value) => {
    setIsCaptchaPassed(true);
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack className="m-auto w-full fill-[#2C3037] text-xs" />
        </button>
        <p className="font-medium w-fit justify-self-center text-[#1E3053]">
          Sign up
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 flex flex-col space-y-3 items-center pt-4 pb-6">
        <p className="text-center text-[#2C3037] text-sm">
          Enter the email you'd like to create your Qcast account.
        </p>
        <span className="w-full flex flex-col items-center space-y-2 px-2">
          <label className="relative w-full ">
            <IoMail color={bg} className="absolute translate-y-1/2 left-1" />
            <input
              className="h-[2rem] text-xs w-full rounded-md pl-6 pr-2 bg-[#FFFFFF80]"
              placeholder="Email Address"
              type="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <ReCAPTCHA
            ref={recaptcha}
            sitekey={config.recaptcha.siteKey}
            type="image"
            onChange={handleRecaptcha}
          />
          <button
            style={{ backgroundColor: bg, color: font }}
            className="w-[70%] text-xs flex-grow rounded-full py-2 shadow-md"
            onClick={() => startSignup()}
          >
            Continue
          </button>
        </span>
      </div>
    </div>
  );
};

export const SignupLastStep = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  const auth = useSelector((store) => store.auth);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState(auth.email);
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const { lastsignupstep, login } = Sign();

  const laststep = () => {
    const input = {
      username,
      email,
      password,
      otp: auth.otp,
    };

    lastsignupstep(input, ({ id, data, msg }) => {
      if (id === 200) {
        login(input, ({ id, data, msg }) => {
          if (id === 200) {
            dispatch({
              type: "auth/signin",
              payload: {
                username: data.username,
                userId: data.userId,
                token: data.token,
              },
            });
            props.view();
          } else {
            alert(msg);
          }
        });
      } else {
        alert(msg);
        if (id === 101) {
          props.getStarted();
        }
      }
    });
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2 shadow-sm">
        <button className="justify-self-start mr-2 w-[1.2rem] aspect-square rounded-full flex flex-col "></button>
        <p className="font-medium w-fit justify-self-center whitespace-nowrap text-[#1E3053]">
          Last step
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 flex flex-col space-y-3 items-center py-4">
        <p className="text-sm text-center text-[#2C3037]">
          To publish your Qcast, you'll need to finish creating your account.
        </p>
        <span className="w-full flex flex-col items-center space-y-2 px-8">
          <label className="relative w-full ">
            <IoPerson color={bg} className="absolute translate-y-1/2 left-1" />
            <input
              className="h-[2rem] text-sm w-full shadow rounded-md pl-6 pr-2 bg-[#FFFFFF80]"
              placeholder="Username"
              type="text"
              value={username}
              autoFocus
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
          <label className="relative w-full ">
            <IoMail color={bg} className="absolute translate-y-1/2 left-1" />
            <input
              className="h-[2rem] text-sm w-full shadow rounded-md pl-6 pr-2 bg-[#FFFFFF80]"
              placeholder="Email"
              type="email"
              value={email}
              disabled
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label className="relative w-full ">
            <IoLockClosed
              color={bg}
              className="absolute translate-y-1/2 left-1"
            />
            <input
              className="h-[2rem] text-sm w-full shadow rounded-md pl-6 pr-2 bg-[#FFFFFF80]"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button
            type="submit"
            style={{ backgroundColor: bg, color: font }}
            className="w-[80%] flex flex-col text-xs flex-grow rounded-full py-2 shadow-md mt-4"
            onClick={() => laststep()}
          >
            <p className="hidden lg:flex mx-auto">
              Create account & publish Qcast
            </p>
            <p className="lg:hidden mx-auto">Create account</p>
          </button>
        </span>
      </div>
    </div>
  );
};

export const SignupVerify = (props) => {
  const theme = useContext(ThemeContext);
  const { bg } = theme;
  const [i, setI] = useState();
  const [ii, setII] = useState();
  const [iii, setIII] = useState();
  const [iv, setIV] = useState();
  const [countDown, setCountDown] = useState({
    timer: 60,
    finished: false,
  });
  const dispatch = useDispatch();

  const userEmail = useSelector((store) => store.auth.email);

  const { verifyOTP, signup } = Sign();

  useEffect(() => {
    let timerInterval;
    function pad(d) {
      return d < 10 ? "0" + d.toString() : d.toString();
    }

    timerInterval = setInterval(() => {
      if (Number(countDown.timer) > 1) {
        setCountDown((prev) => ({
          ...prev,
          timer: pad(prev.timer - 1),
        }));
      } else {
        clearInterval(timerInterval);
        setCountDown({
          timer: pad(0),
          finished: true,
        });
      }
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [countDown.timer]);

  const verify = () => {
    const input = {
      email: userEmail,
      otp: [i, ii, iii, iv].join(""),
    };

    verifyOTP(input, ({ id, msg }) => {
      if (id === 200) {
        dispatch({ type: "auth/setOTP", payload: input.otp });
        props.verified();
      } else {
        alert(msg);
      }
    });
  };

  const handleResendCode = () => {
    setI("");
    setII("");
    setIII("");
    setIV("");

    signup(userEmail, ({ id, msg }) => {
      if (id === 200) {
        alert("Code sent!");
        setCountDown({
          timer: 60,
          finished: false,
        });
      } else {
        alert(msg);
      }
    });
  };

  useMemo(() => {
    iv && verify();
  }, [iv]);

  const handleNextFocus = (e) => {
    let parent = e.target.parentElement;
    let nextInput = parent.nextElementSibling.firstElementChild;

    if (e.target.value) nextInput.focus();
  };

  const handleBackSpace = (e) => {
    let parent = e.target.parentElement;
    let prevInput = parent.previousElementSibling?.firstElementChild;

    if (e.key === "Backspace" || e.keyCode === 8 || e.code === "Backspace") {
      if (!e.target.value) prevInput.focus();
    }
  };

  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack className="m-auto w-full fill-[#2C3037] text-xs" />
        </button>
        <p className="font-medium w-fit justify-self-center whitespace-nowrap text-[#1E3053]">
          Last step
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-full px-2 md:px-8 flex flex-col space-y-3 items-center pt-4 pb-6">
        <p className="text-center text-sm text-[#2C3037]">
          Please enter the verification code we've sent to
          <strong style={{ color: bg }} className="text-[#6497C7] font-medium">
            {" "}
            {userEmail}
          </strong>
        </p>
        <form className="w-[90%] grid grid-cols-4 space-x-2 px-2 place-items-center">
          <label className="relative w-full flex flex-row items-center ">
            <input
              autoFocus
              style={{ color: bg }}
              className="text-center shadow aspect-square w-[75%] text-lg text-[#6497C7] font-bold mx-auto rounded-md "
              maxLength={1}
              type="text"
              onChange={(e) => {
                setI(e.target.value);
                handleNextFocus(e);
              }}
              onKeyDown={handleBackSpace}
            />
          </label>
          <label className="relative w-full flex flex-row items-center">
            <input
              style={{ color: bg }}
              className="text-center aspect-square shadow w-[75%] text-lg font-bold mx-auto rounded-md "
              maxLength={1}
              type="text"
              onChange={(e) => {
                setII(e.target.value);
                handleNextFocus(e);
              }}
              onKeyDown={handleBackSpace}
            />
          </label>
          <label className="relative w-full flex flex-row items-center">
            <input
              style={{ color: bg }}
              className="text-center aspect-square shadow w-[75%] text-lg font-bold mx-auto rounded-md "
              maxLength={1}
              type="text"
              onChange={(e) => {
                setIII(e.target.value);
                handleNextFocus(e);
              }}
              onKeyDown={handleBackSpace}
            />
          </label>
          <label className="relative w-full flex flex-row items-center">
            <input
              style={{ color: bg }}
              className="text-center aspect-square shadow w-[75%] text-lg font-bold mx-auto rounded-md "
              maxLength={1}
              type="text"
              onChange={(e) => setIV(e.target.value)}
              onKeyDown={handleBackSpace}
            />
          </label>
        </form>
        <span className="flex flex-col space-y-2 items-center text-sm text-[#515A6B]">
          <p>Resend new code in: 00:{countDown.timer}</p>
          <button>Didn't recieve a verification code?</button>
          <span className="flex flex-row">
            <button
              className=""
              style={{ color: bg }}
              disabled={!countDown.finished}
              onClick={handleResendCode}
            >
              Resend code
            </button>
            <button
              style={{ color: bg }}
              className="pl-1 ml-1 border-l-2 border-[#515A6B]"
              onClick={props.back}
            >
              Change email
            </button>
          </span>
        </span>
      </div>
    </div>
  );
};

export const SignupVerified = (props) => {
  const theme = useContext(ThemeContext);
  const { bg, font } = theme;
  return (
    <div className="w-[19rem] md:w-[24rem] lg:w-[29rem] rounded-[20px] flex flex-col bg-[#FFFFFF80] backdrop-blur-[50px] overflow-hidden">
      <nav className="bg-[#FFFFFF80] w-full grid grid-cols-3 px-2 items-center py-2 shadow-sm">
        <button
          className="justify-self-start mr-2 w-[1.2rem] h-[1.2rem] aspect-square rounded-full bg-[#8DACCD54] flex flex-col "
          onClick={props.back}
        >
          <IoArrowBack className="m-auto w-full fill-[#2C3037] text-xs" />
        </button>
        <p className="font-medium w-fit justify-self-center whitespace-nowrap text-[#1E3053]">
          You're all set!
        </p>
        <span></span>
      </nav>
      {/* BODY */}
      <div className="w-1/3 mt-2 mx-auto rounded-full aspect-square bg-gradient-to-b from-[#F1F9FF] to-[#DCE8F6]  flex flex-col shadow-md">
        <img src={check} alt="" className="m-auto w-[4rem]" />
      </div>
      <div className="w-full px-2 md:px-8 lg:px-[4rem] flex flex-col space-y-3 items-center pt-2 pb-6">
        <p className="text-center text-[#515A6B]">
          Account successfully verified!
        </p>
        <button
          type="button"
          style={{ backgroundColor: bg, color: font }}
          onClick={props.lastStep}
          className="w-[70%] text-sm flex-grow rounded-full py-2 shadow-md"
        >
          Complete your registration!
        </button>
      </div>
    </div>
  );
};
